/**
 * Import function triggers from their respective submodules:
 *
 * const {onCall} = require("firebase-functions/v2/https");
 * const {onDocumentWritten} = require("firebase-functions/v2/firestore");
 *
 * See a full list of supported triggers at https://firebase.google.com/docs/functions
* https://us-central1-cruds-5b98f.cloudfunctions.net/getNewsMijenta 
* Commands Firebase
* npm install firebase-functions    
* firebase login       
* firebase login:add  
* firebase login:list  
* firebase login:use emilio.malaman@bairesdev.com
* firebase projects:list    
* firebase use altos-planoslabs
* firebase deploy --only hosting:mijentacocktails       
* firebase serve
*/


import React, { useState, useEffect } from "react";
import RecipeList from "../components/RecipeList";
import recipesData from "../recipesData.json";
import Navbar from "./NavBarCheck";
import { Container, Grid, GridRow, GridColumn } from "semantic-ui-react";
import 'semantic-ui-css/semantic.min.css';
import "../App.css";

function CocktailMain() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredRecipes, setFilteredRecipes] = useState([]);

  const handleFilterSelect = (selectedFilters) => {
    setSelectedFilters(selectedFilters);
    setCurrentPage(1);
  };
  const handlePageChange = (pageNumber, e) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    const filtered = recipesData.recipes
      .filter((recipe) => filterRecipesBySearch(recipe) && filterRecipesByFilters(recipe))
      .sort((b, a) => new Date(a.publishdate) - new Date(b.publishdate));

    setFilteredRecipes(filtered);
  }, [selectedFilters, searchTerm]);

  useEffect(() => {
    if (currentPage > Math.ceil(filteredRecipes.length / recipesPerPage)) {
      setCurrentPage(1);
    }
  }, [currentPage, filteredRecipes]);

  const filterRecipesBySearch = (recipe) => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const typeMatch = recipe.typeDrink.toLowerCase().includes(lowerSearchTerm);
    const nameMatch = recipe.name.toLowerCase().includes(lowerSearchTerm);
    const complexityMatch = recipe.complexity.toLowerCase().includes(lowerSearchTerm);
    const authorMatch = recipe.author.toLowerCase().includes(lowerSearchTerm);
    const authorNameMatch = recipe.authorName.toLowerCase().includes(lowerSearchTerm);
    const tequilaMatch = recipe.tequilaType.toLowerCase().includes(lowerSearchTerm);
    const instructionsMatch = recipe.instructions.toLowerCase().includes(lowerSearchTerm);
    const ingredientsMatch = recipe.ingredients.some((ingredient) =>
      ingredient.toLowerCase().includes(lowerSearchTerm)
    );

    return (
      nameMatch || complexityMatch || ingredientsMatch || typeMatch || authorMatch || tequilaMatch || instructionsMatch || authorNameMatch
    );
  };

  const filterRecipesByFilters = (recipe) => {
    const showCocktailMatch = recipe.showCocktail === "YES";
    const checkboxMatches = selectedFilters.every(filter => {
      if (filter === "classic drink" && recipe.typeDrink.toLowerCase() === "classic drink") return true;
      if (filter === "signature drink" && recipe.typeDrink.toLowerCase() === "signature drink") return true;
      if (filter === "blanco" && recipe.tequilaType.toLowerCase() === "blanco") return true;
      if (filter === "reposado" && recipe.tequilaType.toLowerCase() === "reposado") return true;
      if (filter === "cristalino" && recipe.tequilaType.toLowerCase() === "cristalino") return true;
      if (filter === "easy" && recipe.complexity.toLowerCase() === "easy") return true;
      if (filter === "medium" && recipe.complexity.toLowerCase() === "medium") return true;
      if (filter === "hard" && recipe.complexity.toLowerCase() === "hard") return true;
      return false;
    });

    return showCocktailMatch && checkboxMatches;
  };

  const recipesPerPage = 9;

  const totalPages = Math.ceil(filteredRecipes.length / recipesPerPage);

  const indexOfLastRecipe = currentPage * recipesPerPage;
  const indexOfFirstRecipe = indexOfLastRecipe - recipesPerPage;

  const currentRecipes = filteredRecipes.slice(
    indexOfFirstRecipe,
    indexOfLastRecipe
  );

  const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <Container fluid>
      <Navbar onSelectFilters={handleFilterSelect} />
      <Grid stackable>
        <GridRow>
          <GridColumn stretched>
            <input
              type="text"
              placeholder="Type an ingredient or a name to find a cocktail"
              className="text-search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </GridColumn>
        </GridRow>

        <GridRow stretched columns={3}>
          {currentRecipes.length === 0 ? (
            <GridColumn textAlign="center" width={16}>
              <div className="nothing-found-warning">No cocktails found. Try other options.</div>
            </GridColumn>
          ) : (
            currentRecipes.map((recipe) => (
              <Grid.Column key={recipe.id}>
                <RecipeList recipes={[recipe]} />
              </Grid.Column>
            ))
          )}
        </GridRow>
        <GridRow>
          <div className="pagination-container">
            {pageNumbers.map((pageNumber) => (
              <button
                key={pageNumber}
                onClick={(e) => {
                  e.preventDefault();
                  handlePageChange(pageNumber);
                }}
                className={`pagination ${currentPage === pageNumber ? 'active' : ''}`}
              >
                {pageNumber}
              </button>
            ))}
          </div>
        </GridRow>
      </Grid>
    </Container>
  );
}

export default CocktailMain;